import { HOME_BOARD } from "./planBoard";

/**
 * s237 (ACROSS-YOUR-PLAN-1 PR B; rule 159) — the search line on the "Across your plan" pages (board 12: Where things
 * are, and Contacts). One piece: the board's magnifier, the page's own placeholder words, 44px tall.
 * s237 (D-237.61, canvas v471): once something is typed, a clear × (board 12's "Clear the search") empties it in one click;
 * Esc does the same.
 */
export function PlanSearch({ value, onChange, placeholder, testId }: {
  value: string;
  onChange: (v: string) => void;
  placeholder: string;
  testId: string;
}) {
  return (
    <label className="flex min-h-11 min-w-0 flex-1 items-center gap-2.5 rounded-[8px] border border-warm-stone bg-warm-white px-3.5 text-[14px] text-warm-charcoal focus-within:border-sage-600">
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" className="shrink-0 text-warm-muted">
        <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>
      <input type="search" value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} aria-label={placeholder}
        onKeyDown={(e) => { if (e.key === "Escape" && value) { e.preventDefault(); onChange(""); } }}
        className="min-w-0 flex-1 bg-transparent outline-none placeholder:text-warm-muted [&::-webkit-search-cancel-button]:hidden" data-testid={testId} />
      {value && (
        <button type="button" onClick={() => onChange("")} title={HOME_BOARD.where.clearSearch} aria-label={HOME_BOARD.where.clearSearch}
          className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-warm-stone-light text-warm-muted hover:text-warm-charcoal" data-testid={`${testId}-clear`}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" /></svg>
        </button>
      )}
    </label>
  );
}
